import IntegrationVacancy from '@/orm/models/Integration/IntegrationVacancy';
import { computed } from '@vue/composition-api';
import useValidation from '@/compositions/useValidation';
import User from '@/orm/models/User/User';

export default function useIntegrationVacancy({
  integration,
  vacancies,
  callback,
} = {}) {
  const { withApiErrorHandling } = useValidation();

  function fetch() {
    return withApiErrorHandling(async () => {
      await IntegrationVacancy.api().fetchAllByProvider(
        User.getAuthUser().company.id,
        integration.id,
        integration.code,
      );
      if (!callback) {
        return;
      }
      await callback();
    });
  }
  if (integration) {
    fetch().then();
  }

  const externalVacancies = computed(() => {
    return vacancies?.length ? vacancies : IntegrationVacancy.query()
      .where('provider', integration.code)
      .get();
  });

  return {
    externalVacancies,
    notLinkedExternalVacancies: computed(() => externalVacancies.value.filter((v) => !v.connected)),
    fetch,
  };
}
